(function () {
	'use strict';

	angular.module('qbePortal').directive('qbPromoCode', ['guideWireService', 'labelService', '$rootScope', '$q', function (guideWireService, labelService, $rootScope, $q) {

		function addValidPromoMessage(wrapper, promoValue) {
			if (wrapper) {
				try {
					$rootScope.$broadcast('valid-campaign', {
						isValid: true,
						promoValue: promoValue
					});
					if ($(wrapper).find('em.valid-promo').length == 0) {
						var promoMessage = labelService.getGlobalOptionLabel('content', 'promo_acknowledged_message');
						$(wrapper).append('<em class="help valid-promo">' + promoMessage + '</em>');
					}
				} catch (ex) {
					console.error('Unable to fetch global message to acknowledge a valid promotional code.');
				}
			}
		}

		function removeValidPromoMessage(wrapper) {
			if (wrapper) {
				$(wrapper).find('em.valid-promo').remove();
				$rootScope.$broadcast('valid-campaign', {
					isValid: false
				});
			}
		}

		function validateInput(element, ngModel) {
			if (!ngModel || typeof (element.val()) != 'string') return;
			var currentValue = element.val();
			var promoWrapper = element.parent('.promo-wrapper');
			if (currentValue && currentValue != '') {
				return guideWireService.isCampaignCodeValid(currentValue)
					.then(function (unique) {
						addValidPromoMessage(promoWrapper, currentValue);
						return $q.resolve();
					}).catch(function () {
						removeValidPromoMessage(promoWrapper);
						return $q.reject();
					});
			} else {
				removeValidPromoMessage(promoWrapper);
				return $q.resolve();
			}
		}

		function _link(scope, element, attrs, ngModel) {
			ngModel.$asyncValidators.qbPromoCode = function (modelValue) {
				return validateInput(element, ngModel);
			}
		}

		return {
			require: 'ngModel',
			link: _link,
		};
	}]);
})();
